import styled from '@emotion/styled';

export {
	AuthContainer as Container,
	AuthEyebrow as Eyebrow,
	AuthFieldBox as FieldBox,
	AuthFormActions as FormActions,
	AuthFormCard as FormCard,
	AuthPage as Page,
	AuthPageHeader as PageHeader,
	AuthSubtitle as Subtitle,
	AuthTitle as Title,
} from '@/styles/authPageLayout';

export { PrimaryButton as Button } from '@/components/common/Button/style';

export const InnerForm = styled.form`
	display: flex;
	flex-direction: column;
	width: 100%;
`;
